/**
 * Monitors focus events on the Chat Interface's text areas, and
 * ensures that the chat stays in view and usaable on mobile-phone browsers.
 *
 *   - "mobile" == Capabilities.isMobile()
 *   - Because we're on "mobile" browsers, we don't support IE
 *   - Because we're on "mobile" browsers, we don't consider persistent chat.
 *   UserAgent String: Mozilla/5.0 (iPhone; CPU iPhone OS 10_0_1 like Mac OSX) AppleWebKit/601.1 (KHTML, like Gecko) CriOS/53.0.2785.86 Mobile/14A403 Safari/601.1.46
 *   Not -             Mozilla/5.0 (iPhone; U; CPU iPhone OS 8_1_1 like Mac OS X; en) AppleWebKit/534.46.0 (KHTML, like Gecko) CriOS/19.0.1084.60 Mobile/9B206 Safari/7534.48.3
 */

/**
 * package: com.inq.flash.client.chatskins
 * class: ChatTextFocusMonitorImplIphoneSafari
 * root Object
 * @constructor
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneCRiOS10 = function() {
	com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneCRiOS10.__super__.call(this);
};
/* __super__ is defined below, and used above :)
 * This is OK because below is operated at load time (as is the definition of the constructor).
 * Above is operated at construction time.
 */
$hxClasses.extend(com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari10,		// The extend defines the __super__
                  com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneCRiOS10,
                  "com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneCRiOS10"
                 );

/** resizeToViewportFocused - Resize the chat area when we have focus and the virtual keyboard is in view
 RTDEV-14612
 Chrome in iOS 10 at this point in time 9/2016 is behaving differently than chrome ios < 10 when it comes to
 reporting the viewport size. Previously on keyboard open, the innerHeight value reflected the change and
 there was no need to use fixed values for keyboard height like its currently done for ios safari. This function
 is similar to the one for Safari7-10 except there is a 44 pix difference which is probably due to safari accounting
 for the bookmark bar. Since we are re-using the safari fixed height tables, we adjust accordingly.
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneCRiOS10.prototype.resizeToViewportFocused = function() {
	/** @type {com.inq.utils.Area} */
	var oldSize = Application.GetArea();
	/** @type {boolean} */
	var gapHeightFix = com.inq.utils.Util.getConfig("iosGapFix", false);
	/** @type {com.inq.ui.Canvas} */
	var chatFooter = Application.application.getMxmlItem("chatFooter");
	/** @type {com.inq.ui.TextArea} */
	var chatWindow = Application.application.getMxmlItem("chatWindow");

	this.viewPort = com.inq.utils.Capabilities.getViewport();

	this.viewPort.h = this.calculateViewableArea();

	if (gapHeightFix && this.iOSGapFixHeight) {
		if (this.chatFooterDefaultHeight == 0) { // this will be 0 when you navigate to a new page and then you do a resume chat.
			this.chatFooterDefaultHeight = chatFooter.getHeight();
		}
		if (this.chatWindowDefaultBottom === null) {
			this.chatWindowDefaultBottom = parseInt(chatWindow.getStyle("bottom"));
		}
		chatFooter.setHeight(com.inq.ui.Container.encodeSize(this.chatFooterDefaultHeight + this.iOSGapFixHeight));
		if (!isNaN(this.chatWindowDefaultBottom)) {
			chatWindow.setStyle("bottom", com.inq.ui.Container.encodeSize(this.chatWindowDefaultBottom + this.iOSGapFixHeight));
		}
	}

	haxe.Log.trace("viewport height: " + this.viewPort.h, { fileName : "ChatTextFocusMonitorImplIphoneCRiOS10.js", lineNumber : 1239, className : "com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneCRiOS10", methodName : "resizeToViewportFocused"});

	Application.SetArea(this.viewPort);

	/* Check to see if the viewport has changed, if it hasn't we do not want to set the area, resize and scroll the transcript down */
	if (this.viewPort.h != oldSize.h || this.viewPort.w != oldSize.w){

		com.inq.utils.Timer.delay(function() {

			com.inq.flash.client.chatskins.SkinControl.cw.scrollToEnd();
			/**
			 * this is to Syncronize scroll events occuring due to keyboard up, and manual scrollTo code
			 */
			Application.Resize();

		}, 100);
	}
};

//observed viewport height diff in pixels from safari, 44 is height of safari bookmark bar probably the reason
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneCRiOS10.CHROME_IOS_HEIGHT_DIFF = 44;
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneCRiOS10.SKIRT_ID = "bottomSkirt";

/**
 * onFocusImpl - Restore the original scroll position & chat dimensions.
 *
 * RTDEV-14984
 * Insert white bar below chat input to cover customer content. This bar is to allow for keyboard open with predictive
 * text off
 *
 * We will place a div layer at the bottom of the page that will be shown during focus or keyboard-up.
 * We eventually scroll to the bottom of the page and this box will then be in view behind the predictive text box
 *
 * @public
 * @param {FocusEvent} ev
 * @param {HTMLElement} element
 * @return {boolean}
 */

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneCRiOS10.prototype.onFocusImpl = function(ev, element) {
	try {
		/** @type {com.inq.ui.Canvas} */
		var background = Application.application.getCanvas("background");
		/** @type {com.inq.ui.ClientBody} */
		var clientBody = new com.inq.ui.ClientBody();
		/** @type {String} */
		var color = (!background) ? "white" : background.getStyle("backgroundColor");


		if (!color) color = "gray";

		/** @type {com.inq.ui.Canvas} */
		var canvas = Application.application.getMxmlItem(com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneCRiOS10.SKIRT_ID);
		if (!canvas) {

			canvas = new com.inq.ui.Html("html:Div", com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneCRiOS10.SKIRT_ID, clientBody);

			canvas.setID(com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneCRiOS10.SKIRT_ID);
			canvas.attachTo(clientBody);
			Application.application.setMxmlItem(canvas);
		}
		/* We need to get the clientHeight of the client page.
		   We then subtract the height of the skirt box
		   This is the absolute location to put the skirt at the bottom of the page
		 */
		/** @type {number} */
		var bottomTop = inqFrame.parent.document.body.clientHeight - 44;
		canvas.setAttribute("class", "tcChat");
		canvas.setAttribute("style", "position:absolute;" +
			"z-index: 9999998;" +
			"right:0px;left:0px;top:"+bottomTop+"px;height:44px;" +
			"display: block;" +
			"background-color:" + color);

		canvas.setVisible("true");

	} catch (e) {
		haxe.Log.trace("Error Thrown: " + e, { fileName : "ChatTextFocusMonitorImplIphoneCRiOS10.js", lineNumber : 115, className : "com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneCRiOS10", methodName : "onFocusImpl"});
	}
	var retVal = com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneCRiOS10.__super__.prototype.onFocusImpl.call(this, ev, element);
	this.onScrollCallback();
	return retVal;
};

/** @private @type {null} */

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneCRiOS10.prototype.onBlurImpl = function(ev, element) {

	/** @type {com.inq.ui.Canvas} */
	var canvasSkirt = Application.application.getMxmlItem(com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneCRiOS10.SKIRT_ID);
	if (canvasSkirt) {
		canvasSkirt.setVisible("false");
	}
/*
 * RTDEV-15607
 * It should be returned back if the inheritance has to work.
 */
	return com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneCRiOS10.__super__.prototype.onBlurImpl.call(this, ev, element);
};
